module.exports = __webpack_public_path__ + "img/banner3.4b350e4a.png";